import React, { useState, useEffect, useContext, useCallback,  } from "react";
import moment from 'moment';
import { Button, Table,  notification, Input, DatePicker, Select } from "antd";
import { SearchOutlined} from "@ant-design/icons";
import axios from "axios";
import GlobalContext from "../../utils/GlobalContext";
import { v4 as uuidv4 } from "uuid";
import LoadingModal from "../../utils/LoadingModal";
import { Link } from "react-router-dom";

const PAGE_SIZE = 15;
const { RangePicker } = DatePicker;
const { Option } = Select;

const OpenInfoTable = () => {
  const globals = useContext(GlobalContext);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: PAGE_SIZE,
  });
  const [searchText, setSearchText] = useState("");
  const [dateRange, setDateRange] = useState("");
  const [meetingTypes, setMeetingTypes] = useState([]);
  const [currentMeetingType, setCurrentMeetingType] = useState(null);

  const columns = [
    {
      title: "Nombre del punto",
      dataIndex: "pointName",
      key: "pointName",
      render: (_, record) => {
        if (record.parentPointName !== null)
          return (
            <p>{record.parentPointName} / {record.pointName}</p>
          )
        else
          return (
            <p>{record.pointName}</p>
          )
      }
    },
    {
      title: "Reunión asociada",
      dataIndex: ["meeting", "meeting_name"],
      key: "meeting",
      render: (_, record) => {
        return (
          <Link to={`/meeting/${record.meeting.id}/execute`}>{record.meeting.meeting_name}</Link>
        )
      }
    },
    {
      title: "Tipo de reunión",
      dataIndex: ["meeting", "meeting_type_name"],
      key: "meeting_type",
    },
    {
      title: "Fecha",
      dataIndex: "startDate",
      key: "startDate",
      render: (_, record) => {
        if (record?.meeting?.startDate !== null)
          return (
            moment(record?.meeting?.startDate).format("DD-MMM-YYYY")
          )
        else
          return (
            <p>Sin fecha</p>
          )
      }
    },
    {
      title: "Responsable",
      dataIndex: "responsible",
      key: "responsible",
    },
    // {
    //   title: "Opciones",
    //   key: "actions",
    //   width: 80,
    //   render: (_, record) => (
    //     <Space size="middle">
    //       <Dropdown
    //         trigger={["click"]}
    //         menu={{
    //           items:[
    //             {
    //               key: '1',
    //               label: 'Editar',
    //               icon:<EditOutlined />,
    //               onClick: () => handleActionClick("edit", record)
    //             },
    //           ],
    //         }}
    //       >
    //         <Button icon={<DownOutlined />} shape="circle" />
    //       </Dropdown>
    //     </Space>
    //   ),
    // },
  ];

  const fetchData = useCallback(
    async (newPagination, search, currentMeetingType, startDate, endDate) => {
      let page = 1;
      let pageSize = PAGE_SIZE;
      if (newPagination) {
        page = newPagination.current;
        pageSize = newPagination.pageSize;
      }
      try {
        setLoading(true);
        await new Promise((resolve) => setTimeout(resolve, 100));
        let params = {
            page,
            limit: pageSize,
            search: search,
            date_from: (startDate) ? moment(startDate).format("YYYY-MM-DD") : null,
            date_to: (endDate) ? moment(endDate).format("YYYY-MM-DD") : null,
            meeting_type_name: currentMeetingType,
          }
        const response = await axios.get(
          `${globals.SERVICE_API_DB}/v1/list-information-closed-report`,
          {
            headers: {
              "x-token": globals.token,
            },
            params,
          }
        );
        if (response.data.status !== 0){
          setLoading(false);
          return;
        }
        console.log("response******", response.data);
        setData(response?.data?.data?.rows);
        if (newPagination) {
          setPagination({
            ...newPagination,
            total: response?.data?.data?.count,
          });
        } else {
          setPagination({
            ...pagination,
            total: response?.data?.data?.count,
          }
          );
        }
        notification.success({
          message: "Información obtenida exitosamente!",
          placement: "bottomRight",
          duration: 2,
        });
      } catch (error) {
        console.log("Error fetching data:", error.response);
        if (error?.response?.data?.status !== -3) {
          console.error("Error fetching data:", error.response);
          notification.error({
            message: "Error obteniendo información!",
            placement: "bottomRight",
            duration: 2,
          });
        }
        else{
          notification.warning({
            message: "No hay reuniones disponibles!",
            placement: "bottomRight",
            duration: 2,
          });
        
        }
      }
      setLoading(false);
    },
    // eslint-disable-next-line
    [globals.SERVICE_SERVICE_API_DB]
  );

  const fetchMeetingTypeData = useCallback(
    async () => {
      try {
        setLoading(true);
        await new Promise((resolve) => setTimeout(resolve, 100));
        const response = await axios.get(
          `${globals.SERVICE_API_DB}/v1/list-information-open-report`,
          {
            headers: {
              "x-token": globals.token,
            },
          }
        );
        if (response.data.status !== 0){
          setLoading(false);
          return;
        }
        console.log("Meeting Types:", response?.data);
        setMeetingTypes(response?.data?.rows);
      } catch (error) {
        console.log("Error fetching data:", error.response);
        notification.error({
          message: "Error obteniendo información!",
          placement: "bottomRight",
          duration: 2,
        });
      }
      setLoading(false);
    },
    // eslint-disable-next-line
    [globals.SERVICE_SERVICE_API_DB]
  );

  useEffect(() => {
    fetchMeetingTypeData();
    fetchData(null, null, null, null, null);
  }, [fetchData, fetchMeetingTypeData]);

  const handleDownloadCSV = async () => {
    console.log("Download CSV");
    try {
      setLoading(true);
      await new Promise((resolve) => setTimeout(resolve, 100));
      let params = {
        search: searchText,
        date_from: (dateRange?.start) ? moment(dateRange?.start).format("YYYY-MM-DD") : null,
        date_to: (dateRange?.end) ? moment(dateRange?.end).format("YYYY-MM-DD") : null,
        meeting_type_name: currentMeetingType
      }
      const response = await axios.get(
        `${globals.SERVICE_API_REPORT}/v1/consult-meeting-information-open-report`,
        {
          headers: {
            "x-token": globals.token,
          },
          params,
          responseType: 'blob'
        }
      );
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'reporte_puntos_info_abiertos.csv');
      document.body.appendChild(link);
      link.click();
      notification.success({
        message: "Descarga exitosa!",
        placement: "bottomRight",
        duration: 2,
      });
      setLoading(false);
    }
    catch (error) {
      setLoading(false);
      console.log("Error fetching data:", error.response);
      notification.error({
        message: "Error obteniendo información!",
        placement: "bottomRight",
        duration: 2,
      });
    }
  }

  async function handleTableChange(newPagination) {
    fetchData(newPagination, searchText, null, dateRange?.start, dateRange?.end);
  }  
  
  const handleChangeMeetingType = async (value) => {
    setCurrentMeetingType(value);
    fetchData(null, searchText, value, dateRange?.start, dateRange?.end);
  }

  const handleRefresh = () => {
    fetchData(null, searchText, null, dateRange?.start, dateRange?.end);
  };

  const handleSearch = async () => {
    console.log("searchText", searchText); 
    console.log("dateRange", dateRange);

    fetchData(null, searchText, null, dateRange?.start, dateRange?.end);
  };

  const handleSearchEnterKey = async (e) => {
    if (e.key === "Enter") {
      handleSearch();
    }
  };

  return (
    <div>
      <div
        style={{ display: "flex", alignItems: "center", marginBottom: "16px" }}
      >
        <h2 style={{ marginRight: "16px" }}>Reporte puntos información abiertos</h2>
        <div style={{ flexGrow: 1, borderBottom: "1px solid #ccc" }} />
        <Button
          onClick={handleRefresh}
          disabled={loading}
          style={{ marginRight: "8px" }}
        >
          Refrescar
        </Button>
      </div>
      <Input
        placeholder="Buscar"
        allowClear
        value={searchText}
        onChange={(e) => setSearchText(e.target.value)}
        style={{ marginBottom: 16, width: 200 }}
        prefix={<SearchOutlined />}
        onKeyDown={handleSearchEnterKey}
      />
      <RangePicker
        style={{ marginBottom: 16, width: 200 }}
        onChange={(date, dateString) => {
          if (dateString[0] === "" || dateString[0] === null) {
            setDateRange("");
          }
          else{
            const startTimestamp = new Date(`${dateString[0]}T00:00:00Z`).getTime();
            const endTimestamp = new Date(`${dateString[1]}T23:59:59Z`).getTime();
            setDateRange({start: startTimestamp, end: endTimestamp});
          }
        }}
      />
      <Select
        style={{ width: 200, marginLeft: 8, marginRight: 8 }}
        value={currentMeetingType}
        onChange={handleChangeMeetingType}
        placeholder="Tipo de reunión"
        allowClear
      >
        {meetingTypes?.map((item) => (
          <Option key={item.meeting_type_name} value={item.meeting_type_name}>
            {item.meeting_type_name}
          </Option>
        ))}
      </Select>
      <Button  type="primary" onClick={handleSearch} style={{ marginRight: "8px" }}>
        Buscar
      </Button>
      <Button onClick={handleDownloadCSV} style={{ marginRight: "8px" }}>
        Descargar
      </Button>
      <div
        className="site-layout-background h-auto"
        style={{
          padding: 10,
          display: "flex",
          flexDirection: "column",
          margin: 0,
          height: "auto",
          minHeight: "350px",
          overflow: "auto",
          backgroundColor: "#ffffff",
        }}
      >
        <Table
          rowKey={(r) => uuidv4()}
          columns={columns}
          dataSource={data}
          pagination={pagination}
          onChange={handleTableChange}
          scroll={{ y: "max-content" }}
          size="small"
        />
      </div>
      <LoadingModal open={loading} />
    </div>
  );
};

export default OpenInfoTable;
